import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import { CryptService } from '@services/crypt/crypt.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private crypt_service = inject(CryptService);
  private publicKey: ArrayBuffer | null = null;
  private publicKeyInitialized = false;
  private publicKeyInitializationPromise: Promise<void> | null = null;

  constructor() {
    this.publicKeyInitializationPromise = this.initializePublicKey();
  }

  private async initializePublicKey(): Promise<void> {
    if (this.publicKeyInitializationPromise) {
      return this.publicKeyInitializationPromise;
    }
    try {
      await this.crypt_service.openDatabase();
      const privateKeyExists = await this.crypt_service.doesPrivateKeyExist();
      if (!privateKeyExists) {
        const keyPair = await this.crypt_service.generateKeyPair();
        this.publicKey = keyPair.publicKey;
        this.publicKeyInitialized = true;
      } else {
        this.publicKey = await this.crypt_service.getPublicKeyFromIndexedDB();
        this.publicKeyInitialized = true;
        if (!this.publicKey) {
          const keyPair = await this.crypt_service.generateKeyPair();
          this.publicKey = keyPair.publicKey;
        }
      }
    } catch (error) {
      this.publicKeyInitialized = true;
    } finally {
      this.publicKeyInitializationPromise = null;
    }
  }

  async setItem(key: string, value: any): Promise<void> {
    if (!this.publicKeyInitialized) {
      await this.initializePublicKey();
      if (!this.publicKey) {
        throw new Error("La chiave pubblica non è ancora stata inizializzata.");
      }
    }
    if (!this.publicKey) {
      throw new Error("La chiave pubblica non è ancora stata inizializzata.");
    }
    const encryptedData = await this.crypt_service.encryptData(value, this.publicKey);
    localStorage.setItem(key, encryptedData);
  }

  async getItem(key: string): Promise<string | null> {
    const storedData = localStorage.getItem(key);
    if (!storedData) return null;
    try {
      const decryptedMessage = await this.crypt_service.decryptData(storedData);
      return decryptedMessage;
    } catch (error) {
      // localStorage.removeItem(key);
      return null;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
